import { NSARouterMakerResult } from "namirasoft-account-react";
import { WorkspaceProps } from "../WorkspaceProps";
import { WorkspaceEntities } from "../WorkspaceEntities";
import { WorkspaceLayout } from "../WorkspaceLayout";

export interface IWorkspaceViewPageProps extends NSARouterMakerResult, WorkspaceProps { }

function WorkspaceViewPage(props: IWorkspaceViewPageProps)
{
	return (
		<WorkspaceLayout {...props}
			action={{
				title: "",
				description: "Examine workspace details and modify it, edit or delete.",
				menus: {}
			}}
			pages={{
				entity: WorkspaceEntities.workspace(props, () => { window.location.reload() }),
				view: {}
			}}
		>
			<></>
		</WorkspaceLayout>
	);
}

export default WorkspaceViewPage;